import { useLocalStorage } from '@f-fertighaus/applications/Next/hooks/useLocalStorage'
import { UserDetails } from '@f-fertighaus/applications/UserAccount/interfaces/User'

export function useUserDetails(initialValue: UserDetails = {}): UserDetails {
  const user = useLocalStorage<UserDetails>('UA', initialValue)

  return user || {}
}
